angular.module('files', ['core', 'angularBootstrapNavTree', 'angularFileUpload'])
    .factory('File', function ($resource) {
        return $resource('/crm/api/files/:uuid', {uuid: '@uuid'}, {
            list: {method: 'GET', isArray: false},
            notArchived: {method: 'GET', isArray: false, params: {isArchived: false}},
            deleteBatch: {method: 'POST', url: '/crm/api/files/batch-delete'},
            update: {method: 'PUT'}
        });
    })
    .service('FileService', function ($rootScope, toastr, modals, File) {
        this.editModal = file => modals.open('app/files/edit-file-modal.html', 'FileEditCtrl', file, {size: "md"}, "$ctrl");
        this.deleteModal = item => {
            return modals.confirmDelete(item.filename, () => {
                return new File(item).$delete(() => {
                    toastr.success("Usunięto " + item.filename);
                    $rootScope.$broadcast('file.saved');
                }).$promise;
            });
        };
        this.deleteMany = items => {
            const uuids = (items || []).map(item => item && item.uuid).filter(uuid => uuid).filter((uuid, index, values) => values.indexOf(uuid) === index)
            if (!uuids.length) {
                return
            }
            return modals.confirmDelete(`zaznaczone pliki (${uuids.length})`, () => File.deleteBatch({uuids: uuids}).$promise.then(() => $rootScope.$broadcast('file.saved')))
        }
    })
    .component('fileListSection', {
        bindings: {
            page: '<',
            selection: '<'
        },
        templateUrl: 'app/files/list-section-files.html',
        controller: function ($scope, $state, FileService) {
            this.FileService = FileService;
            this.$onInit = () => this.selection.setItems(this.page.list)
            $scope.$on('file.saved', () => $state.go($state.current, {page: null}, {reload: $state.current}));
        }
    })
    .controller('FileListFolderCtrl', function ($scope, $state, $stateParams, Folder, File, toastr, FileUploadFoldersService, FolderService, FileService, selection) {
        $scope.FileUploadFoldersService = FileUploadFoldersService;
        $scope.FileService = FileService;
        $scope.selection = selection;

        $scope.filters = angular.copy($stateParams);
        $scope.resetForm = () => {
            $scope.filters = {};
        }
        $scope.folderTree = {};
        $scope.folderTreeInitialSelect = $stateParams.folder || {};

        $scope.folders = [{id: null, name: ".."}];
        Folder.query(folders => {
            $scope.folders = $scope.folders.concat(folders);
            FolderService.formatFolders($scope.folders);
        });

        $scope.onFolderSelect = folder => {
            $scope.selectedFolder = folder;
            $state.go($state.current, {page: null, folder: folder.id});
        };

        $scope.uploadFile = () => {
            let folder = $scope.selectedFolder;

            $scope.folderTree.select_branch(folder);
            let uploadForm = {
                folderTree: $scope.folderTree,
                folders: $scope.folders,
                initialSelection: folder,
                selected: $scope.folderTree.get_selected_branch()
            };
            FileUploadFoldersService.uploadModal(uploadForm);
        }
        $scope.addSubfolder = () => {
            let folder = $scope.selectedFolder;
            if(folder.id == null)
                return

            $scope.folderTree.select_branch(folder);
            let folderForm = {
                id: null,
                parent: {
                    id: folder.id,
                    name: folder.name
                }
            };
            FolderService.addSubfolderModal(folderForm).then(item => $scope.folderTree.add_branch(folder, item));
        }
        $scope.editFolder = () => {
            let folder = $scope.selectedFolder;
            if(folder.id == null)
                return

            $scope.folderTree.select_branch(folder);
            let parent = $scope.folderTree.get_parent_branch(folder);
            let folderForm = {
                id: folder.id,
                name: folder.name,
                parent: parent
            };
            FolderService.folderEditModal(folderForm).then(item => angular.extend(folder, item));
        }

        $scope.deleteFolder = () => {
            let folder = $scope.selectedFolder;
            if(folder.id == null)
                return

            FolderService.deleteFolderModal(folder)
                .then(() => {
                    let parent = $scope.folderTree.get_parent_branch(folder);
                    if (angular.isDefined(parent)) {
                        let index = parent.subfolders.indexOf(folder);
                        if (index < 0) {
                            toastr.error("Błąd aktualizacji listy folderu. Odśwież stronę", "Błąd!");
                        } else {
                            parent.subfolders.splice(index, 1);
                            parent.children.splice(index, 1);
                        }
                    } else {
                        let index = $scope.folders.indexOf(folder);
                        if (index < 0) {
                            toastr.error("Błąd aktualizacji listy folderu. Odśwież stronę", "Błąd!");
                        } else {
                            $scope.folders.splice(index, 1);
                        }
                    }
                });
        }
        $scope.addRootSubfolder = () => {
            let folder = {
                id: null
            };
            FolderService.addSubfolderModal(folder).then(item => $scope.folderTree.add_root_branch(item));
        };
    })
    .controller('FileEditCtrl', function ($scope, $rootScope, $uibModalInstance, data, File, toastr) {
        this.item = {};
        copyProperties(data, this.item, ["uuid", "filename", "description", "isPublic", "isLinkActive", "isAssignable", "isArchived"]);

        function copyProperties($source, $destination, properties) {
            angular.forEach(properties, key => {
                if ($source.hasOwnProperty(key)) {
                    $destination[key] = $source[key];
                }
            });
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            let promise
            if (this.item.uuid !== null) {
                promise = File.update(this.item).$promise
            } else {
                promise = File.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast("file.saved", result)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        };
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_FILES",
            path: "/files",
            ico: "fa fa-fw fa-files-o",
            name: 'file.menu',
            order: 70
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('fileListAbstract', {
            parent: 'app',
            data: {
                authorities: ['ROLE_FILES']
            },
            resolve: {
                selection: TableSelection => TableSelection.create()
            },
            views: {
                'content@': {
                    templateUrl: 'app/files/list-section-folders.html',
                    controller: 'FileListFolderCtrl',
                }
            }
        });
        $stateProvider.state('fileList', {
            parent: 'fileListAbstract',
            url: '/files?{page:int}&{size:int}&sort&search&folder&periodStart&periodEnd',
            views: {
                'files@^': "fileListSection"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (File, $stateParams) => File.list(angular.copy($stateParams)).$promise
            }
        });
    });
